// extracted by mini-css-extract-plugin
module.exports = {"faq_main":"Faq_faq_main__37NEW","main":"Faq_main__2vLrD","panel":"Faq_panel__3AJPA"};